module.exports = {"520181002":"青龙山街道","520181003":"巢凤街道","520181004":"滨湖街道","520181100":"红枫湖镇","520181101":"站街镇","520181102":"卫城镇","520181103":"新店镇","520181104":"暗流镇","520181105":"犁倭镇","520181201":"麦格苗族布依族乡","520181203":"王庄布依族苗族乡","520181204":"流长苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520181.json
// module id = 2588
// module chunks = 0